export enum UrlId {
  QRCODE_WELCOME = 'qrcodegenerator:welcome',
  QRCODE_BUILDER = 'qrcodegenerator:builder',
  QRCODE_SAVE = 'qrcodegenerator:save',
  QRCODE_WRAPUP = 'qrcodegenerator:wrap-up',
}
